var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinPushLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 3L17 9.22271L15.9624 10.2596L15.444 9.74115L12.3333 12.8518L11.8149 15.4447L10.7773 16.4816L7.66667 13.3702L4.03687 17L3 15.9631L6.62979 12.3333L3.51844 9.22271L4.55531 8.1851L7.14896 7.66667L10.2596 4.55604L9.74115 4.03761L10.778 3H10.7773ZM11.2965 5.59292L7.87125 9.01739L5.80191 9.4317L10.5683 14.1981L10.9819 12.1287L14.4071 8.70427L11.2965 5.59292Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinPushLine);
export default __webpack_public_path__ + "static/media/icon-pin-push-line.9031d9f06b9878d1b0b25d33b9ae6720.svg";
export { ForwardRef as ReactComponent };